export { HomePage, HomePagePreview } from "../components/pages/home";
export { SectionPage } from "../components/pages/section";
export { TagPage } from "../components/pages/tag";
export { SearchPage } from "../components/pages/search";
export { AuthorPage } from "../components/pages/author";
export { CatalogPage } from "../components/pages/catalog";
export { NotFoundPage } from "../components/pages/not-found";
